import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import { Avatar, Box, Typography } from '@mui/material';
import TimeAgo from 'javascript-time-ago';
import { useTranslation } from 'react-i18next';
import { NotificationFieldsFragment } from '../../../../../../../../generated/core-api/graphql-react-query';

export default function UserInvitedNotificationBox(props: { notification: NotificationFieldsFragment }) {
  const { notification } = props;
  const { t, i18n } = useTranslation('widgets');
  const timeAgo = new TimeAgo(i18n.language);
  return (
    <>
      <Avatar className="owner">
        <PersonAddAltIcon />
      </Avatar>
      <Box className="message">
        <Typography variant="subtitle1">
          <strong>{notification.event.author?.displayName}</strong>
          {t('notifications.user.invited')}
        </Typography>
        <Typography variant="body1" component="div">
          <div className="project">{notification.event.user?.email}</div>
        </Typography>
        <Typography variant="subtitle2">
          {timeAgo.format(new Date(notification.date))}
        </Typography>
      </Box>
    </>
  );
}
